import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { ApplicationContextService } from '../globalServices/application-context.service';

export const SCHOOL_CODE_HEADER = 'schoolcode';

// Whenever ApplicationContextService has a schoolCode set (ops-admin cross-school
// viewing in manage-applications, or a student working through an invitation flow
// for a school that differs from their own auth claim), add it to all API requests
// so the backend can scope the request to that school's tenant.
export const schoolCodeInterceptor: HttpInterceptorFn = (req, next) => {
  const applicationContext = inject(ApplicationContextService);

  const schoolCode = applicationContext.getSchoolCode();
  if (schoolCode && req.url.includes('/api/')) {
    req = req.clone({
      setHeaders: { [SCHOOL_CODE_HEADER]: schoolCode },
    });
  }

  return next(req);
};
